import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Site } from '@debbie/common/dist';
import { getRKIRegistrations } from '@debbie/common/dist/customers/helpers';
import { TenantStatus } from '@debbie/common/dist/tenants';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors';
import THEME from '../../../theme';
import ArrowRight from '../../Icons/ArrowRight';
import Phone from '../../Icons/Phone';
import Money from '../../Money';
const UserRkiRegistrations = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const tenant = useSelector(selectTenant);
    const rkiRegistrations = (tenant === null || tenant === void 0 ? void 0 : tenant.status) === TenantStatus.Demo
        ? getDemoRKIRegistration()
        : getRKIRegistrations(props.user.details);
    if (!(rkiRegistrations && rkiRegistrations.length))
        return null;
    if (site === Site.Client) {
        if (!rkiRegistrations)
            return null;
        return (React.createElement("h2", null,
            "(",
            rkiRegistrations.length,
            ") ",
            lang.debtorInfo.rkiRegis));
    }
    if (!rkiRegistrations)
        return null;
    return (React.createElement("div", null,
        !props.noHeader && React.createElement("h2", null, lang.debtorInfo.rkiRegis),
        rkiRegistrations.map((registration) => {
            var _a, _b;
            const slettetDato = registration.SlettetDato
                ? moment(registration.SlettetDato, 'DDMMYYYY')
                : null;
            return (React.createElement(RKIRegistration, { key: ((_b = (_a = registration === null || registration === void 0 ? void 0 : registration.Debitor) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.debitorNr) +
                    (registration === null || registration === void 0 ? void 0 : registration.AdministratorsRefNr), isDeleted: slettetDato === null || slettetDato === void 0 ? void 0 : slettetDato.isBefore(moment()) },
                React.createElement("h4", null,
                    registration.Kreditor &&
                        registration.Kreditor.Navnedata &&
                        registration.Kreditor &&
                        registration.Kreditor.Navnedata.Navn,
                    ' ',
                    registration.Kreditor && registration.Kreditor.TelefonNr && (React.createElement("small", null,
                        React.createElement(Phone, { style: {
                                margin: '2px 2px -2px',
                            } }),
                        registration.Kreditor.TelefonNr)),
                    registration.Beloeb && (React.createElement("span", null,
                        React.createElement(Money, { amount: parseFloat(`${registration.Beloeb}`.replace(',', '.')) *
                                100 })))),
                registration.Fundament && React.createElement("p", null, registration.Fundament),
                registration.RegistreringBemaerkning && (React.createElement("p", null,
                    lang.RKI.remark,
                    ': ',
                    registration.RegistreringBemaerkning)),
                registration.RegistreringStatus && (React.createElement("p", null,
                    lang.RKI.status,
                    ': ',
                    registration.RegistreringStatus)),
                React.createElement("p", null,
                    lang.debtorInfo.administrator,
                    ":",
                    ' ',
                    registration.Administrator &&
                        registration.Administrator.Navnedata &&
                        registration.Administrator &&
                        registration.Administrator.Navnedata.Navn,
                    ' ',
                    registration.Administrator &&
                        registration.Administrator.TelefonNr && (React.createElement("small", null,
                        React.createElement(Phone, { style: {
                                margin: '2px 2px -2px',
                            } }),
                        registration.Administrator &&
                            registration.Administrator.TelefonNr)),
                    React.createElement("span", { style: {
                            float: 'right',
                        } },
                        registration.VideregivelsesDato &&
                            moment(registration.VideregivelsesDato, 'DDMMYYYY').format(THEME.DATE_FORMAT),
                        ' ',
                        React.createElement(ArrowRight, { style: { margin: '0.2em 0 -0.2em' } }),
                        ' ',
                        (slettetDato === null || slettetDato === void 0 ? void 0 : slettetDato.isBefore(moment()))
                            ? `${lang.debtorInfo.deleted}`
                            : `${lang.debtorInfo.toBedeleted}`,
                        ' ', slettetDato === null || slettetDato === void 0 ? void 0 :
                        slettetDato.format(THEME.DATE_FORMAT))),
                registration.SletteAarsag && (React.createElement("p", null,
                    lang.RKI.deleteReason,
                    ': ',
                    registration.SletteAarsag.Tekst)),
                React.createElement("div", { style: { clear: 'both' } })));
        })));
};
export default UserRkiRegistrations;
const RKIRegistration = styled.div `
  padding: 10px 0;
  border-bottom: 1px solid darkgrey;
  opacity: ${(props) => (props.isDeleted ? 0.7 : 1)};

  &:last-child {
    border-bottom: none;
  }

  p {
    font-size: 0.7em;
    margin-top: 0.3em;
    opacity: 0.6;
    font-weight: bold;
  }

  h4 {
    span {
      float: right;
    }
  }

  p,
  h4 {
    margin: 0;
  }
`;
const getDemoRKIRegistration = () => [
    {
        Beloeb: '12905,64',
        Debitor: {
            Navnedata: { Navn: 'Testdebitor ApS' },
            attributes: { 'xsi:type': 'FirmaData', debitorNr: '123' },
        },
        Kreditor: {
            Navnedata: { Navn: 'Testkreditor A/S' },
            TelefonNr: '12345678',
            attributes: { 'xsi:type': 'FirmaData' },
            HovedBranche: { Kode: '521000' },
        },
        Fundament: 'Fundament',
        SlettetDato: '19062027',
        Administrator: {
            Navnedata: { Navn: 'Advokatfirmaet Test ApS' },
            TelefonNr: '12345678',
            attributes: { 'xsi:type': 'FirmaData' },
        },
        KreditorsRefNr: 'test',
        VideregivelsesDato: '05102022',
        AdministratorsRefNr: '123456',
    },
    {
        Beloeb: '1200,00',
        Debitor: {
            Navnedata: { Navn: 'Testdebitor ApS' },
            attributes: { 'xsi:type': 'FirmaData', debitorNr: '123' },
        },
        Kreditor: {
            Navnedata: { Navn: 'Testkreditor A/S' },
            TelefonNr: '12345678',
            attributes: { 'xsi:type': 'FirmaData' },
            HovedBranche: { Kode: '521000' },
        },
        Fundament: 'Fundament',
        SlettetDato: '19062027',
        Administrator: {
            Navnedata: { Navn: 'Advokatfirmaet Test ApS' },
            TelefonNr: '12345678',
            attributes: { 'xsi:type': 'FirmaData' },
        },
        KreditorsRefNr: 'test',
        VideregivelsesDato: '05102022',
        AdministratorsRefNr: '123456',
    },
];
//# sourceMappingURL=UserRkiRegistrations.js.map